import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAudioAnnouncementDevices } from '../../services/AudioAnnouncementService';
import type { AudioAnnouncementDevicesResponse } from '../../types/AudioAnnouncement';

function useGetAudioAnnouncementDevices(
  fleetId: string | null,
  audioId: string | null,
): UseQueryResult<AudioAnnouncementDevicesResponse> {
  const enabled = Boolean(fleetId && audioId);
  return useQuery(
    ['audio-announcement-devices', fleetId ?? '', audioId ?? ''],
    (): Promise<AudioAnnouncementDevicesResponse> => getAudioAnnouncementDevices(fleetId as string, audioId as string),
    {
      retry: 1,
      enabled,
      refetchInterval: enabled ? 3000 : false,
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetAudioAnnouncementDevices;
